import React, { useState, useEffect, useCallback } from "react";
import { Clock, CheckCircle, DollarSign, Wallet } from 'lucide-react'; // 確保引入這些圖標

function UsageRecords({ darkMode }) {
  const [owner, setOwner] = useState("");
  const [records, setRecords] = useState([]);
  const [waitingRecords, setWaitingRecords] = useState({ disc60: 0, disc100: 0 });
  const [waitingDetails, setWaitingDetails] = useState([]);
  // 在現有的 state 聲明中添加
 const [availableAccounts, setAvailableAccounts] = useState({ disc60: 0, disc100: 0 });
// 在現有的 state 聲明中添加
const [waitingCurrentPage, setWaitingCurrentPage] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  
  // 計算等待解封帳戶的分頁數據
const indexOfLastWaitingRecord = waitingCurrentPage * recordsPerPage;
const indexOfFirstWaitingRecord = indexOfLastWaitingRecord - recordsPerPage;
const currentWaitingRecords = waitingDetails.slice(indexOfFirstWaitingRecord, indexOfLastWaitingRecord);
const totalWaitingPages = Math.ceil(waitingDetails.length / recordsPerPage);
  
  // 在組件頂部添加這個函數
	const formatDateTime = (dateTimeString) => {
	  return dateTimeString ? dateTimeString.replace('T', ' ') : '';
	};
  
	const fetchAvailableAccounts = useCallback(async () => {
	  try {
		const response = await fetch(
		  `https://api.mcvanuatu.com/api/accounts/availableAccount`
		);

		if (!response.ok) {
		  throw new Error("無法獲取可用帳戶數據");
		}

		const data = await response.json();
		setAvailableAccounts({
		  disc60: data.filter(record => record.discountType === 99).length,
		  disc100: data.filter(record => record.discountType === 100).length
		});
	  } catch (err) {
		console.error("獲取可用帳戶統計失敗:", err);
	  }
	}, []);

  // 使用 useCallback 來記憶化函數，避免不必要的重新創建
  const fetchWaitingCount = useCallback(async () => {
    try {
      const response = await fetch(
        `https://api.mcvanuatu.com/api/accounts/waitingAccount`
      );

      if (!response.ok) {
        throw new Error("無法獲取可用優惠券數據");
      }

      const data = await response.json();
		setWaitingDetails(data); // 保存完整數據
      setWaitingRecords({
        disc60: data.filter(record => record.discountType === 60).length,
        disc100: data.filter(record => record.discountType === 100).length
      });
    } catch (err) {
      console.error("獲取可用優惠券統計失敗:", err);
    }
  }, []); // 空依賴數組，因為函數不依賴於任何 props 或 state

  // 設置自動更新
	// 修改現有的 useEffect，加入新的 fetch
	useEffect(() => {
	  fetchWaitingCount();
	  fetchAvailableAccounts(); // 添加這行

	  const intervalId = setInterval(() => {
		fetchWaitingCount();
		fetchAvailableAccounts(); // 添加這行
	  }, 2000);

	  return () => {
		clearInterval(intervalId);
	  };
	}, [fetchWaitingCount, fetchAvailableAccounts]);

  // 原有的查詢功能
  const fetchRecords = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(
        `https://api.mcvanuatu.com/api/accounts/owner/${owner}`
      );

      if (!response.ok) {
        throw new Error("找不到該用戶或用戶資料。");
      }

      const data = await response.json();
      if (data.length === 0) {
        throw new Error("該用戶沒有任何數據。");
      }
      setRecords(data);
    } catch (err) {
      setError(err.message);
      setRecords([]);
    }
    setLoading(false);
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = records.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(records.length / recordsPerPage);

  // 表格標題
  const tableHeaders = {
    owner: "擁有者",
    email: "電郵",
    number: "號碼",
    discountType: "優惠卷",
    createdTime: "創建時間",
    unlockTime: "解封時間",
    ownerAcquisitionTime: "擁有時間"
  };

  return (
    <div className="container mx-auto py-6 max-w-full">
		{/* 等待解封區域 */}
		<div className="mb-8">
		  <div className="flex items-center gap-2 mb-6">
			<Clock className={`w-6 h-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`} />
			<h3 className={`text-xl md:text-xl font-bold ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`}>
			  等待解封的帳戶 Waiting Account
			</h3>
		  </div>
		  
		  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
			<div className={`relative ${
			  darkMode ? "bg-[#1E1E1E]" : "bg-white"
			} border border-[#333333] rounded-xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl`}>
			  <div className="flex items-center justify-between">
				<div className="flex items-center gap-3">
				  <div className={`p-3 rounded-lg ${darkMode ? "bg-[#121212]" : "bg-[#F5F5F5]"}`}>
					<DollarSign className={`w-6 h-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`} />
				  </div>
				  <h4 className="font-bold text-lg">HKDSR1824</h4>
				</div>
				<div className={`text-3xl font-bold ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`}>
				  {waitingRecords.disc60}
				</div>
			  </div>
			</div>

			<div className={`relative ${
			  darkMode ? "bg-[#1E1E1E]" : "bg-white"
			} border border-[#333333] rounded-xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl`}>
			  <div className="flex items-center justify-between">
				<div className="flex items-center gap-3">
				  <div className={`p-3 rounded-lg ${darkMode ? "bg-[#121212]" : "bg-[#F5F5F5]"}`}>
					<Wallet className={`w-6 h-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`} />
				  </div>
				  <h4 className="font-bold text-lg">SKIPKUNGFU</h4>
				</div>
				<div className={`text-3xl font-bold ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`}>
				  {waitingRecords.disc100}
				</div>
			  </div>
			</div>
		  </div>
		</div>

		{/* 可用帳戶區域 */}
		<div className="mb-8">
		  <div className="flex items-center gap-2 mb-6">
			<CheckCircle className={`w-6 h-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`} />
			<h3 className={`text-xl md:text-xl font-bold ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`}>
			  可用的帳戶 Available Account
			</h3>
		  </div>

		  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
			<div className={`relative ${
			  darkMode ? "bg-[#1E1E1E]" : "bg-white"
			} border border-[#333333] rounded-xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl`}>
			  <div className="flex items-center justify-between">
				<div className="flex items-center gap-3">
				  <div className={`p-3 rounded-lg ${darkMode ? "bg-[#121212]" : "bg-[#F5F5F5]"}`}>
					<DollarSign className={`w-6 h-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`} />
				  </div>
				  <h4 className="font-bold text-lg">HKDSR1824</h4>
				</div>
				<div className={`text-3xl font-bold ${
				  darkMode ? "text-green-400" : "text-green-600"
				}`}>
				  {availableAccounts.disc60}
				</div>
			  </div>
			</div>

			<div className={`relative ${
			  darkMode ? "bg-[#1E1E1E]" : "bg-white"
			} border border-[#333333] rounded-xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl`}>
			  <div className="flex items-center justify-between">
				<div className="flex items-center gap-3">
				  <div className={`p-3 rounded-lg ${darkMode ? "bg-[#121212]" : "bg-[#F5F5F5]"}`}>
					<Wallet className={`w-6 h-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`} />
				  </div>
				  <h4 className="font-bold text-lg">SKIPKUNGFU</h4>
				</div>
				<div className={`text-3xl font-bold ${
				  darkMode ? "text-green-400" : "text-green-600"
				}`}>
				  {availableAccounts.disc100}
				</div>
			  </div>
			</div>
		  </div>
		</div>
		
{/* 等待解封帳戶詳細資訊 */}
<div className="mb-8">
  <h3 className={`text-xl md:text-xl font-bold mb-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`}>
    待解封的可取帳戶資訊 Pending Account Information
  </h3>

  {waitingDetails.length > 0 ? (
    <div className="mt-6">
      <div className="hidden md:block overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden border border-[#333333] rounded-lg">
            <table className="min-w-full divide-y divide-[#333333]">
              <thead className={darkMode ? "bg-[#333333]" : "bg-[#f2f2f2]"}>
                <tr>
                  {['電郵', '號碼', '優惠卷', '創建時間', '解封時間'].map((header) => (
                    <th
                      key={header}
                      className={`px-3 py-2 text-sm font-semibold text-center ${
                        darkMode ? "text-white" : "text-[#333333]"
                      }`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-[#333333]">
                {currentWaitingRecords.map((record, index) => (
                  <tr
                    key={index}
                    className={`hover:bg-[#FFFFFF] ${
                      darkMode ? "hover:bg-opacity-10" : "hover:bg-opacity-20"
                    }`}
                  >
                    <td className="px-3 py-2 text-sm text-center whitespace-nowrap">{record.email}</td>
                    <td className="px-3 py-2 text-sm text-center whitespace-nowrap">{record.number}</td>
                    <td className="px-3 py-2 text-sm text-center whitespace-nowrap">{record.discountType}</td>
                    <td className="px-3 py-2 text-sm text-center whitespace-nowrap">{formatDateTime(record.createdTime)}</td>
                    <td className="px-3 py-2 text-sm text-center whitespace-nowrap">{formatDateTime(record.unlockTime)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 移動版卡片視圖 */}
      <div className="md:hidden space-y-4">
        {currentWaitingRecords.map((record, index) => (
          <div
            key={index}
            className={`rounded-lg shadow-md p-4 ${
              darkMode
                ? "bg-[#1E1E1E] border border-[#333333]"
                : "bg-white border border-[#333333]"
            }`}
          >
            <div className="flex justify-between py-2 border-b border-[#333333]">
              <span className="font-medium text-sm">電郵</span>
              <span className="text-sm">{record.email}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-[#333333]">
              <span className="font-medium text-sm">號碼</span>
              <span className="text-sm">{record.number}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-[#333333]">
              <span className="font-medium text-sm">優惠卷</span>
              <span className="text-sm">{record.discountType}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-[#333333]">
              <span className="font-medium text-sm">創建時間</span>
              <span className="text-sm">{formatDateTime(record.createdTime)}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-[#333333] last:border-0">
              <span className="font-medium text-sm">解封時間</span>
              <span className="text-sm">{formatDateTime(record.unlockTime)}</span>
            </div>
          </div>
        ))}
      </div>

      {/* 分頁控制 */}
      {totalWaitingPages > 1 && (
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          {Array.from({ length: totalWaitingPages }, (_, index) => (
            <button
              key={index}
              onClick={() => setWaitingCurrentPage(index + 1)}
              className={`px-3 py-1 rounded-md text-sm ${
                waitingCurrentPage === index + 1
                  ? darkMode
                    ? "bg-[#404040] text-white"
                    : "bg-[#333333] text-white"
                  : darkMode
                  ? "bg-[#1E1E1E] text-[#FFFFFF]"
                  : "bg-gray-200"
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  ) : (
    <p className="text-center text-gray-500">目前沒有等待解封的帳戶。</p>
  )}
</div>
      <h3 className={`text-xl md:text-xl font-bold mb-6 ${darkMode ? "text-[#FFFFFF]" : "text-[#333333]"}`}>
        使用者數據 User Data
      </h3>

      {/* 搜索和統計區域 */}
      <div className="space-y-4 md:space-y-6">
        <div className="flex flex-col md:flex-row gap-3 items-center">
          <input
            type="text"
            placeholder="用戶名 Account"
            value={owner}
            onChange={(e) => setOwner(e.target.value)}
            className={`w-full md:w-auto p-2 border rounded-md transition duration-200 ${
              darkMode ? "bg-[#1E1E1E] text-[#FFFFFF] border-[#404040]" : "bg-white text-[#331a00] border"
            }`}
          />
			<button
			  onClick={fetchRecords}
			  className={`w-full md:w-auto px-4 py-2 rounded-md font-semibold shadow-md transition duration-200 ${
				darkMode
				  ? "bg-[#404040] text-white hover:bg-[#505050] hover:text-white"  // 深色模式
				  : "bg-[#2C2C2C] text-white hover:bg-[#3C3C3C]"  // 淺色模式
			  }`}
			>
			  查閱用戶數據 Fetch User Data
			</button>

			<button
			  onClick={() => {
				fetchRecords();
				fetchWaitingCount();
			  }}
			  className={`w-full md:w-auto px-4 py-2 rounded-md font-semibold shadow-md transition duration-200 ${
				darkMode
				  ? "bg-[#404040] text-white hover:bg-[#505050] hover:text-white"  // 深色模式
				  : "bg-[#2C2C2C] text-white hover:bg-[#3C3C3C]"  // 淺色模式
			  }`}
			>
			  刷新數據 Refresh
			</button>
        </div>

      </div>

      {/* 載入和錯誤提示 */}
      {loading && <p className="mt-4 text-blue-500">Loading...</p>}
      {error && (
        <div className={`mt-4 p-2 border rounded ${
          darkMode ? "bg-red-800 text-white border-red-600" : "bg-red-100 text-red-700 border-red-400"
        }`}>
          <p>Error: {error}</p>
        </div>
      )}

      {/* 數據表格部分保持不變 */}
      {currentRecords.length > 0 && (
        <div className="mt-6">
          <div className="hidden md:block overflow-x-auto">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden border border-[#333333] rounded-lg">
                <table className="min-w-full divide-y divide-[#333333]">
                  <thead className={darkMode ? "bg-[#333333]" : "bg-[#f2f2f2]"}>
                    <tr>
                      {Object.values(tableHeaders).map((header) => (
                        <th
                          key={header}
                          className={`px-3 py-2 text-sm font-semibold text-center ${
                            darkMode ? "text-white" : "text-[#333333]"
                          }`}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#333333]">
                    {currentRecords.map((record, index) => (
                      <tr
                        key={index}
                        className={`hover:bg-[#FFFFFF] ${
                          darkMode ? "hover:bg-opacity-10" : "hover:bg-opacity-20"
                        }`}
                      >
                        {Object.keys(tableHeaders).map((key) => (
							<td key={key} className="px-3 py-2 text-sm text-center whitespace-nowrap">
							  {key.includes('Time') ? formatDateTime(record[key]) : record[key]}
							</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 移動版卡片視圖 */}
          <div className="md:hidden space-y-4">
            {currentRecords.map((record, index) => (
              <div
                key={index}
                className={`rounded-lg shadow-md p-4 ${
                  darkMode
                    ? "bg-[#1E1E1E] border border-[#333333]"
                    : "bg-white border border-[#333333]"
                }`}
              >
                {Object.entries(tableHeaders).map(([key, label]) => (
					<div key={key} className="flex justify-between py-2 border-b border-[#333333] last:border-0">
					  <span className="font-medium text-sm">{label}</span>
					  <span className="text-sm">
						{key.includes('Time') ? formatDateTime(record[key]) : record[key]}
					  </span>
					</div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}

      {currentRecords.length === 0 && !loading && !error && (
        <p className="mt-4 text-gray-500 text-center">沒有可顯示的數據。</p>
      )}

      {/* 分頁控制 */}
      {totalPages > 1 && (
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index + 1)}
              className={`px-3 py-1 rounded-md text-sm ${
                currentPage === index + 1
                  ? darkMode
                    ? "bg-[#404040] text-white"
                    : "bg-[#333333] text-white"
                  : darkMode
                  ? "bg-[#1E1E1E] text-[#FFFFFF]"
                  : "bg-gray-200"
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default UsageRecords;